<script>
import NewForm from './New'

export default {
  mixins: [NewForm],
  methods: {
    turnBack() {
      this.$confirm({ content: '一時保存に戻して宜しいでしょうか？' }).then(
        () => {
          this.$http
            .put(
              `shipping-advices/turn-back/${this.sa.id}?version=${
                this.sa.version
              }`
            )
            .then(() => {
              this.$message('', '一時保存に戻しました。')
              this.load()
            })
            .catch((res) => this.showError(res))
        }
      )
    },
    load() {
      this.selected = []
      this.$http
        .get(`/shipping-advices/${this.$route.query.id}?view=B0401`)
        .then((res) => {
          this.sa = res.data

          this.sa.packages.forEach((p, index) => {
            p.seq = new Date().getTime() + index * 1000
          })
          this.sa.packages = this.sa.packages.sort((a, b) => {
            return a.seq - b.seq
          })
        })
        .then(() => {
          this.initNGVData()
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
    remove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          this.$http
            .delete(`shipping-advices/${this.$route.query.id}`)
            .then(() => {
              this.$router.go(-1)
            })
          this.$message('', this.$t('app.messages.removeSuccess'))
        }
      )
    },
    save() {
      this.setRequiredAndNextTick(false, () => {
        if (!this.$refs.form.validate()) return
        if (this.M3BiggerThan100()) {
          this.$message('', this.$t('B0400.messages.errors.m3_more_than_100'))
          return
        }
        this.changeBlNo()
        this.$http
          .put(`shipping-advices/${this.$route.query.id}?view=B0401`, this.sa)
          .then((res) => {
            this.edit(res.data.id)
          })
          .catch((res) => {
            this.showError(res)
          })
      })
    },
  },
  mounted() {
    this.load()
  },
}
</script>
